export const version = '3.3.5'
export const name = 'js-libp2p'
